var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:(_vm.styleObject()),attrs:{"href":_vm.link,"target":_vm.target}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }